<template>
    <div>
        <table v-if="!analytical" class="table b-table table-sm">
            <thead class="thead-dark">
                <tr>
                    <th class="text-center">Tipo</th>
                    <th v-for="month in months" class="text-center" colspan="4">{{ month.name }}</th>
                    <th class="text-center" colspan="2">Total</th>
                </tr>
                <tr>
                    <th class="text-center">{{ form.type == 'salesmans' ? 'Vendedores' : 'Equipes' }}</th>
                    <template v-for="month in months">
                        <th class="text-center">Cotas</th>
                        <th class="text-center">Valor das Cartas</th>
                        <th class="text-center">%</th>
                        <th class="text-center">Ticket Médio</th>
                    </template>
                    <th class="text-center">Cotas</th>
                    <th class="text-center">Valor das Cartas</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, name) in proposals">
                    <td>{{ name }}</td>
                    <template v-for="month in months">
                        <td class="text-center link" @click="showAnalitical(name, itensMonth(item, month.id), month)">{{ itensMonth(item, month.id).length }}</td>
                        <td class="text-center">R${{ sum(itensMonth(item, month.id), 'value') | price }}</td>
                        <td class="text-center">{{ (itensMonth(item, month.id).length / itensMonth(proposals, month.id).length) * 100 | price }}%</td>
                        <td class="text-center">R${{ sum(itensMonth(item, month.id), 'value') / (itensMonth(item, month.id).length || 1) | price }}</td>
                    </template>
                    <td class="text-center">{{ item.length }}</td>
                    <td class="text-center">R${{ sum(item, 'value') | price }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr role="row">
                    <td role="columnheader" scope="col"><strong>Totais</strong></td>
                    <template v-for="month in months">
                        <td role="columnheader" scope="col" class="text-center"><strong>{{ itensMonth(proposals, month.id).length }}</strong></td>
                        <td role="columnheader" scope="col" class="text-center"><strong>R${{ sum(itensMonth(proposals, month.id), 'value') | price }}</strong></td>
                        <td class="text-center">-</td>
                        <td role="columnheader" scope="col" class="text-center"><strong>{{ sum(itensMonth(proposals, month.id), 'value') / (itensMonth(proposals, month.id).length || 1) | price }}</strong></td>
                    </template>
                    <td class="text-center"><strong>{{ count(proposals) }}</strong></td>
                    <td class="text-center"><strong>R${{ sum(proposals, 'value') | price }}</strong></td>
                </tr>
            </tfoot>
        </table>
        <table v-else class="table b-table table-sm">
            <thead class="thead-dark">
                <tr>
                    <th>{{ form.type == 'salesmans' ? 'Vendedor' : 'Equipe' }}: {{ name }}</th>
                    <th colspan="3">Período: {{ month.name }}</th>
                    <th>
                        <b-button size="sm" variant="dark" class='dont-print' @click='hideAnalitical()'>Voltar para Sintético</b-button>
                    </th>
                </tr>
                <tr class="thead-light">
                    <th class="text-center">Cliente</th>
                    <th class="text-center">Contrato</th>
                    <th class="text-center">Grupo</th>
                    <th class="text-center">Cota</th>
                    <th class="text-center">Valor da Carta</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection">
                    <td>{{ item.client }}</td>
                    <td class="text-center">{{ item.proposal }}</td>
                    <td class="text-center">{{ item.group }}</td>
                    <td class="text-center">{{ item.quota }}</td>
                    <td class="text-center">R${{ item.value | price }}</td>
                </tr>
                <tr v-if="collection.length == 0">
                    <td class="text-center" colspan="5">Nenhum item encontrado!</td>
                </tr>
            </tbody>
            <tfoot>
                <tr role="row">
                    <td role="columnheader" scope="col"><strong>Totais</strong></td>
                    <td class="text-center">{{ collection.length }}</td>
                    <td class="text-center">-</td>
                    <td class="text-center">-</td>
                    <td class="text-center">R${{ sum(collection, 'value') | price }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
    import groupBy from '@/helpers/groupBy.js';
    import Vue from 'vue';

    export default {
        computed: {
            proposals: {
                get() {
                    const groupByCol = groupBy(this.form.type == 'salesmans' ? 'name' : 'team')
                    if (this.items) {
                        return groupByCol(this.items);
                    } else {
                        return [];
                    }
                }
            }
        },
        data() {
            return {
                analytical: false,
                form: {},
                collection: [],
                month: {
                    id: 0,
                    name: '-'
                },
                months: [],
                ranges: [],
            };
        },
        methods: {
            breakMonths() {
                var self = this;
                var init_month = parseInt(Vue.moment(self.form.date_at[0]).format('M'));
                var end_month = parseInt(Vue.moment(self.form.date_at[1]).format('M'));
                var init_year = parseInt(Vue.moment(self.form.date_at[0]).format('YYYY'));
                var end_year = parseInt(Vue.moment(self.form.date_at[1]).format('YYYY'));
                var months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

                if (init_year != end_year) {
                    if (init_month > end_month) {
                        end_month = init_month - 1;
                    } else {
                        end_month = 11;
                    }
                    init_month = 0;
                } else {
                    init_month--;
                    end_month--;
                }

                while (init_month <= end_month) {
                    this.months.push({
                        id: init_month,
                        name: months[init_month]
                    });

                    init_month++;
                }
            },
            count(_proposals){
                var count = 0;

                for (let [key, items] of Object.entries(_proposals)) {
                    count += items.length;
                }

                return count;
            },
            hideAnalitical() {
                this.analytical = false;
            },
            itensMonth(_proposals, _month) {
                var proposals = [];

                if (Array.isArray(_proposals)) {
                    _proposals.forEach(function (_proposal) {
                        var saleMonth = parseInt(Vue.moment(_proposal.sale_at).format('M')) - 1;
                        if (saleMonth == _month) {
                            proposals.push(_proposal);
                        }
                    });
                } else {
                    for (let [key, items] of Object.entries(_proposals)) {
                        items.forEach(function (_proposal) {
                            var saleMonth = parseInt(Vue.moment(_proposal.sale_at).format('M')) - 1;
                            if (saleMonth == _month) {
                                proposals.push(_proposal);
                            }
                        });
                    }
                }

                return proposals;
            },
            showAnalitical(_name, _proposals, _month) {
                var self = this;

                self.name = _name;
                self.collection = _proposals;
                self.month = _month;

                self.analytical = true;
            },
            sum(_proposals, _reducer) {
                var sum = 0;

                if (Array.isArray(_proposals)) {
                    _proposals.forEach(function (_proposal) {
                        sum += parseFloat(_proposal[_reducer]);
                    });
                } else {
                    for (let [key, items] of Object.entries(_proposals)) {
                        items.forEach(function (_proposal) {
                            sum += parseFloat(_proposal[_reducer]);
                        });
                    }
                }

                return sum;
            },
            reportData() {
                 var self = this;

                return {
                    'headers': self.months.map(month => month.name),
                    'rows': Object.entries(self.proposals).map(entry => {
                        const salesman = entry[0];
                        const proposals = entry[1];
                        return {
                            'salesman': salesman,
                            'columns': self.months.map(month => {
                                return {
                                    'proposals_amount': self.itensMonth(proposals, month.id).length,
                                    'total_value': self.sum(self.itensMonth(proposals, month.id), 'value'),
                                    'global_percent': (self.itensMonth(proposals, month.id).length / (self.itensMonth(self.proposals, month.id).length || 1)) * 100,
                                    'value_average': self.sum(self.itensMonth(proposals, month.id), 'value') / (self.itensMonth(proposals, month.id).length || 1),
                                };
                            }),
                            'totals' : {
                                'proposals_amount': proposals.length,
                                'total_value': self.sum(proposals, 'value'),
                            },
                        };
                    }),
                    'totals': {
                        'columns': self.months.map(month => {
                            return {
                                'proposals_amount': self.itensMonth(self.proposals, month.id).length,
                                'total_value': self.sum(self.itensMonth(self.proposals, month.id), 'value'),
                                'value_average': self.sum(self.itensMonth(self.proposals, month.id), 'value') / (self.itensMonth(self.proposals, month.id).length || 1),
                            };
                        }),
                        'totals': {
                            'proposals_amount': self.count(self.proposals),
                            'total_value': self.sum(self.proposals, 'value'),
                        },
                    },
                };
            },
        },
        mounted() {
            var self = this;

            self.form = JSON.parse(self.$route.query.form);

            self.hideAnalitical();

            self.breakMonths();
        },
        props: ['date_type', 'items']
    };
</script>
